import * as yup from 'yup'

const NAME_PATTERN_MESSAGE = 'Names cannot have special characters'
const EMAIL_PATTERN_MESSAGE = 'Email is not in valid format'
const EMAIL_REQUIRED = 'Email is required'
const PASSWORD_REQUIRED = 'Password is required'
const VERIFICATION_CODE_REQUIRED = 'Verification code is required'

const namePattern = /^[a-zA-Z \-.'`]+$/
const emailPattern =
  /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const optionalButRequiredIfPresent = (message: string) =>
  yup
    .string()
    .nullable()
    .test('required-if-present', message, (value) => {
      if (value === undefined) return true
      if (value === '' || value === null) return false
      return true
    })

const validationSchema = yup.object({
  firstName: optionalButRequiredIfPresent('First name is required')
    .matches(namePattern, { message: NAME_PATTERN_MESSAGE, excludeEmptyString: true })
    .max(50, 'This field cannot exceed the maximum allowed characters'),
  lastName: optionalButRequiredIfPresent('Last name is required')
    .matches(namePattern, { message: NAME_PATTERN_MESSAGE, excludeEmptyString: true })
    .max(50, 'This field cannot exceed the maximum allowed characters'),
  email: optionalButRequiredIfPresent(EMAIL_REQUIRED)
    .matches(emailPattern, { message: EMAIL_PATTERN_MESSAGE, excludeEmptyString: true })
    .max(100, 'This field cannot exceed the maximum allowed characters'),
  username: optionalButRequiredIfPresent(EMAIL_REQUIRED)
    .matches(emailPattern, { message: EMAIL_PATTERN_MESSAGE, excludeEmptyString: true })
    .max(100, 'This field cannot exceed the maximum allowed characters'),
  passcode: optionalButRequiredIfPresent(PASSWORD_REQUIRED).matches(/^(?=.*[a-z]).{8,}$/, {
    message:
      'Password requirements were not met. Password requirements: at least 8 characters, a lowercase letter.',
    excludeEmptyString: true,
  }),
  password: optionalButRequiredIfPresent(PASSWORD_REQUIRED),
  verificationCode: optionalButRequiredIfPresent(VERIFICATION_CODE_REQUIRED),
})

export default validationSchema
